if (!customElements.get('brands-tabs')) {
    customElements.define(
        'brands-tabs',
        class BrandsTabs extends HTMLElement {
            constructor() {
                super();
                this.tabs = this.querySelectorAll('a');
                this.tabs.forEach((button) =>
                    button.addEventListener('click', this.onTabClick.bind(this))
                );
            }

            onTabClick(event) {
                const button = event.target;
                const buttonSiblings = button.closest('div').querySelectorAll('a');

                buttonSiblings.forEach((button) => {
                    button.classList.remove('button--primary');
                    button.classList.add('button--secondary');
                });
                button.classList.remove('button--secondary');
                button.classList.add('button--primary');
            }
        }
    );
}
